export default __webpack_public_path__ + "static/media/payrunsettings.fb12f287.svg";